const PERMISSION_KEY= "core:permission_group_mapping";
const PAGE_URL = {
    PERMISSION_GROUP_MAPPING_PAGE: "/admin/core/permission-group-mapping"
}

export {PERMISSION_KEY, PAGE_URL}

